<template>
    <div class="selling-view">
        <goodsItemView v-for="(goods,index) in sellings" :goods='goods' :key='index'>
        </goodsItemView>
    </div>
</template>

<script>
    import goodsItemView from "../goodsItemView/goodsItemView.vue";
    export default {
        name: "sellingView",
        components: {
            goodsItemView
        },
        data() {
            return {
                sellings: []
            };
        },
        created() {
            var that = this;
            this.$ajax
                .get("/json/selling-list.json")
                .then(function (response) {
                    console.log(response.data);
                    that.sellings = response.data;
                });
            // .catch(function(err) {
            //   consolog(err);
            // });
        },

    };
</script>

<style  lang="scss">
    .selling-view {
        border-left: 1px solid #bbbbbb;
        border-top: 1px solid #bbbbbb;
        overflow: hidden;
    }
</style>